import React, { useEffect, createElement } from 'react';
import { OfferBar } from './components/OfferBar';
import { ProgressBar } from './components/ProgressBar';
import { HeroSection } from './components/HeroSection';
import { VideoSection } from './components/VideoSection';
import { PainPointsSection } from './components/PainPointsSection';
import { BenefitsAndTopicsSection } from './components/BenefitsAndTopicsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { GeoPricingProvider } from './hooks/GeoPricingContext';
import { LazySection } from './components/LazySection';
import { SocialProofToast } from './components/SocialProofToast';
import { AboutSection } from './components/AboutSection';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Set page title
    document.title = 'Comandos Eléctricos';
    // Defer Facebook Pixel by 3 seconds for faster initial load
    const pixelTimeout = setTimeout(() => {
      !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', '1672032480458980');
      window.fbq('track', 'PageView');
    }, 3000);
    return () => clearTimeout(pixelTimeout);
  }, []);
  return <GeoPricingProvider data-id="element-0">
      <div className="font-poppins text-[15px] leading-relaxed text-dark-gray bg-cream overflow-x-hidden min-h-screen pt-10" data-id="element-1">
        <OfferBar data-id="element-2" />
        <ProgressBar data-id="element-3" />
        <HeroSection data-id="element-4" />
        <VideoSection data-id="element-5" />
        <LazySection data-id="element-6">
          <PainPointsSection data-id="element-7" />
        </LazySection>
        <LazySection data-id="element-8">
          <BenefitsAndTopicsSection data-id="element-9" />
        </LazySection>
        <LazySection minHeight="600px" data-id="element-10">
          <PurchaseSection data-id="element-11" />
        </LazySection>
        <LazySection minHeight="400px" data-id="element-12">
          <BonusSection data-id="element-13" />
        </LazySection>
        <LazySection minHeight="400px" data-id="element-14">
          <TestimonialsSection data-id="element-15" />
        </LazySection>
        <LazySection data-id="element-16">
          <GuaranteeSection data-id="element-17" />
        </LazySection>
        <LazySection data-id="element-18">
          <FaqSection data-id="element-19" />
        </LazySection>
        <LazySection minHeight="400px" data-id="element-20">
          <FinalOfferSection data-id="element-21" />
        </LazySection>
        <LazySection data-id="element-22">
          <AboutSection data-id="element-23" />
        </LazySection>
        <LazySection data-id="element-24">
          <Footer data-id="element-25" />
        </LazySection>
        <SocialProofToast data-id="element-26" />
      </div>
    </GeoPricingProvider>;
}